var map = {
	"./piriArtworkBg.JPG": 58,
	"./placeholder_1.jpg": 59,
	"./placeholder_2.jpg": 60,
	"./placeholder_3.jpg": 61,
	"./placeholder_4.jpg": 62,
	"./placeholder_5.jpg": 63,
	"./placeholder_6.jpg": 64,
	"./placeholder_7.jpg": 65,
	"./placeholder_8.jpg": 66,
	"./placeholder_9.jpg": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;